import fullGamblingCompliance from './fullGamblingCompliance';
import shortGamblingCompliance from './shortGamblingCompliance';

export {
    fullGamblingCompliance,
    shortGamblingCompliance,
};



// WEBPACK FOOTER //
// /src/js/common/gamblingCompliance/Skybet/index.js